import React from 'react';
import styled, { css } from 'styled-components';
import Label from './Label';

const StyledRadioGroup = styled.div`
  ${({ inline }) =>
    inline &&
    css`
      display: flex;

      ${Label} {
        margin-right: 16px;
      }
    `}

  input[type='radio'] {
    padding: 0;
    margin: 0 8px 0 0;

    + span {
      margin: 0 24px 0 0;
    }

    &:disabled + span {
      opacity: 0.6;
    }
  }
`;

const RadioGroup = React.forwardRef(
  (
    {
      disabled = false,
      inline = false,
      options = [],
      labelProperty = 'label',
      valueProperty = 'value',
      ...registerProps
    },
    ref,
  ) => (
    <StyledRadioGroup inline={inline}>
      {options.map((option) => (
        <Label key={option[valueProperty]}>
          <input
            disabled={disabled}
            ref={ref}
            type="radio"
            value={option[valueProperty]}
            {...registerProps}
          />
          <span>{option[labelProperty]}</span>
        </Label>
      ))}
    </StyledRadioGroup>
  ),
);

export default RadioGroup;
